var map = {
	"./bryan.svg": "853b",
	"./cristhian.svg": "a470",
	"./dr-juanca.svg": "e0cb",
	"./dr-rickys.svg": "384b",
	"./jahir.svg": "d01f",
	"./javier-flores.svg": "e7ec",
	"./jeremy.svg": "9edc",
	"./kathiusca.svg": "594a",
	"./med-datos.svg": "d6de",
	"./med-icando.svg": "3ac8",
	"./patrick.svg": "038d",
	"./rodrigo.svg": "421c",
	"./sinapxis-med.svg": "fcd0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "68b4";